import { TOOLTIP_SHOW, TOOLTIP_HIDE } from '../constants';

export default function toolTipReducer(state = {}, action) {
  switch (action.type) {
    case TOOLTIP_SHOW: {
      const newState = { ...state };
      if (!newState.hasOwnProperty(action.payload.value)) {
        newState[action.payload.value] = {};
      }

      newState[action.payload.value].visible = true;
      return newState;
    }

    case TOOLTIP_HIDE: {
      const newState = { ...state };
      if (!newState.hasOwnProperty(action.payload.value)) {
        newState[action.payload.value] = {};
      }

      newState[action.payload.value].visible = false;
      return newState;
    }

    default:
      return state;
  }
}
